export const storeToken = (token,role) => {
  localStorage.setItem("tokenInv", token);
  localStorage.setItem("roleInv", role);
};

export const getToken = () => {
  return localStorage.getItem("tokenInv");
};

export const getRole = () => {
  return localStorage.getItem("roleInv");
};

export const clearAuthData = () => {
  localStorage.clear();
  sessionStorage.clear();
};
